import axios from '@/axios';

const RESOURCE_NAME = '/user-columns';

export default {
    getColumns(type) {
        return axios.get(`${RESOURCE_NAME}/get-columns?type=${type}`)
    },

    getColumnsForTracker(trackerId) {
        return axios.get(`${RESOURCE_NAME}/get-columns?tracker_id=${trackerId}`)
    },

    getColumnsForManage(type, useType, trackerId = 0) {
        return axios.get(`${RESOURCE_NAME}/get-columns-for-manage?type=${type}&use_type=${useType}&tracker_id=${trackerId}`)
    },

    hasSettings(type, trackerId = 0) {
        return axios.get(`${RESOURCE_NAME}/has-settings?type=${type}&tracker_id=${trackerId}`)
    },

    updateColumns(type, useType, trackerId, columns) {
        return axios.post(`${RESOURCE_NAME}/update-columns?type=${type}&use_type=${useType}&tracker_id=${trackerId}`, {'columns': columns})
    },

    removePersonalColumns(trackerId) {
        return axios.post(`${RESOURCE_NAME}/remove-personal-columns?tracker_id=${trackerId}`)
    },
}
